import type { Work } from "@/types";
import { workTypeLabel } from "@/utils/format";
import { Link } from "react-router-dom";

interface WorkCardProps {
  work: Work;
}

export default function WorkCard({ work }: WorkCardProps) {
  return (
    <div
      className="group relative flex flex-col rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all duration-300"
      data-product-shop
    >
      <Link to={`/works/${work.id}`} className="block relative w-full aspect-[3/4] overflow-hidden">
        <img
          src={work.cover}
          alt={`${work.title} 影视作品封面`}
          title={`${work.title} - 佐山爱影视作品`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 top-0 p-3 flex items-start justify-between">
          <span className="px-2.5 py-1 rounded-md text-[11px] font-medium bg-primary-950/75 text-background-100 backdrop-blur-sm">
            {workTypeLabel(work.type)}
          </span>
          <span className="flex items-center gap-1 px-2 py-1 rounded-md text-[11px] font-medium bg-accent-500/95 text-primary-950">
            <i className="ri-star-fill text-[10px]" />
            {work.rating.toFixed(1)}
          </span>
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-950/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
          <span className="text-sm text-background-100 flex items-center gap-1.5">
            <i className="ri-arrow-right-circle-line text-base" />
            查看详情
          </span>
        </div>
      </Link>

      <div className="p-4 flex flex-col gap-2">
        <Link to={`/works/${work.id}`} className="block">
          <h3 className="font-heading font-semibold text-base text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors line-clamp-1">
            {work.title}
          </h3>
        </Link>
        <div className="flex items-center justify-between gap-2 text-xs text-foreground-500">
          <span className="truncate">{work.genre}</span>
          <span className="flex-shrink-0">{work.year}</span>
        </div>
      </div>
    </div>
  );
}